

import Clients from "../components/Services/Clients";
import Service from "../components/Services/Service";
import WhatWeDo from "../components/Services/WhatWeDo";
import WorkWithUs from "../components/Services/WorkWithUs";


export default function Services() {
 

  return (
    <main style={{ backgroundColor: "#ffffff" }}>

      <div>
      <WhatWeDo />
       <Service />
        <Clients />
        <WorkWithUs />
      </div>

    </main>
  );
}